import { useCallback } from 'react'

import type { Roles } from '@b-stock/account-api-client'

import { useCurrentAccountQuery } from './account'

export const useRoles = () => {
  const { data: { roles = {} } = {} } = useCurrentAccountQuery()

  const hasRole = useCallback((role: Roles) => !!roles[role], [roles])

  return {
    roles,
    hasRole,

    // Why hardcoded? Because lots of accounts-portal was written under the
    // assumption that it would be used only by buyers.
    // This is a bad assumption... but acceptable for the few places that use this.
    role: 'buyer',
    isBuyer: true,
  } as const
}
